// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__20h4N","sendOtp":"AuthorizeToLogin_sendOtp__1Z_ZO"};